import { useAuth } from '@/components/auth/authProvider';
import { isPalmettoFinanceUser } from '@/components/auth/RequirePricingAdminUser';
import { PayoutTransactionFilterName } from '@/components/Payouts/PayoutTransactionsFilter';
import { PayoutTransactionTableColumnName } from '@/components/Payouts/PayoutTransactionTable';
import { Box, Card } from '@palmetto/palmetto-components';
import { useMemo } from 'react';

import { ProjectTransactionSort, UserPermissions } from 'types';

import { FilterablePayoutTransactionTable } from '../FilterablePayoutTransactionTable';

export const AllTransactions = () => {
  const { claims } = useAuth();
  const isPalmettoFinanceReaderOrAdmin = useMemo(() => {
    return (
      isPalmettoFinanceUser(claims) &&
      (claims?.permissions?.includes(UserPermissions.lightReachAccountingAdmin) ||
        claims?.permissions?.includes(UserPermissions.lightReachAccountingReader))
    );
  }, [claims]);
  const hideColumns = useMemo(() => {
    const columns: PayoutTransactionTableColumnName[] = ['projectExternalId', 'pauseExpirationDate'];
    if (!isPalmettoFinanceReaderOrAdmin) {
      columns.push('payee.name');
      columns.push('tags');
    }
    return columns;
  }, [isPalmettoFinanceReaderOrAdmin]);

  const hideFilters = useMemo(() => {
    const columns: PayoutTransactionFilterName[] = ['pauseExpirationDate', 'pausedDueToPaymentPlan'];
    if (!isPalmettoFinanceReaderOrAdmin) {
      columns.push('payeeName');
      columns.push('payoutHold');
      columns.push('clawbackRuleName');
      columns.push('isManual');
      columns.push('payeeType');
    }
    return columns;
  }, [isPalmettoFinanceReaderOrAdmin]);

  const hideSort = useMemo(() => {
    const sorts: ProjectTransactionSort[] = ['pausedExpirationDateAsc', 'pausedExpirationDateDesc'];
    if (!isPalmettoFinanceReaderOrAdmin) {
      sorts.push('payeeNameAsc', 'payeeNameDesc');
    }
    return sorts;
  }, [isPalmettoFinanceReaderOrAdmin]);

  return (
    <Card padding="xs" marginTop="0">
      <Card.Header>
        <Box direction="row" justifyContent="space-between" alignItems="center">
          <Box fontSize="xl" fontWeight="medium">
            All Transactions
          </Box>
        </Box>
      </Card.Header>
      <Box margin="0 lg 0 lg">
        <FilterablePayoutTransactionTable
          hideColumns={hideColumns}
          hideFilters={hideFilters}
          enabledButtons={['export', 'addTransaction', 'addToBatch']}
          isCompact
          showPagination
          hideSort={hideSort}
        />
      </Box>
    </Card>
  );
};
